import React from "react";
import { usePanelTheme } from "../context/themeContext";

export default function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  accent = "blue",
}) {
  const { theme } = usePanelTheme();

  const accentStyles = {
    blue:
      theme === "dark"
        ? "from-blue-600/55 via-cyan-500/30 to-sky-400/20 border-blue-400/35"
        : "from-blue-200 via-sky-100 to-cyan-50 border-blue-300",
    emerald:
      theme === "dark"
        ? "from-emerald-600/55 via-green-500/30 to-lime-400/20 border-emerald-400/35"
        : "from-emerald-200 via-green-100 to-lime-50 border-emerald-300",
    amber:
      theme === "dark"
        ? "from-amber-600/55 via-orange-500/30 to-yellow-400/20 border-amber-400/35"
        : "from-amber-200 via-orange-100 to-yellow-50 border-amber-300",
    violet:
      theme === "dark"
        ? "from-violet-600/55 via-fuchsia-500/30 to-purple-400/20 border-violet-400/35"
        : "from-violet-200 via-fuchsia-100 to-purple-50 border-violet-300",
    slate:
      theme === "dark"
        ? "from-slate-500/40 via-slate-400/20 to-slate-300/10 border-slate-400/25"
        : "from-slate-200 via-slate-100 to-slate-50 border-slate-300",
  };

  const titleClass =
    theme === "dark"
      ? "text-white/80"
      : "text-slate-700";

  const valueClass =
    theme === "dark"
      ? "text-white"
      : "text-slate-900";

  const subtitleClass =
    theme === "dark"
      ? "text-white/72"
      : "text-slate-600";

  const iconShellClass =
    theme === "dark"
      ? "bg-white/10 text-white ring-1 ring-white/15"
      : "bg-white/85 text-slate-700 ring-1 ring-black/5";

  return (
    <div
      className={`relative overflow-hidden rounded-[20px] border bg-gradient-to-br p-3.5 sm:rounded-[24px] sm:p-5 shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-lg ${
        accentStyles[accent] || accentStyles.blue
      }`}
    >
      {theme === "dark" ? (
        <div className="pointer-events-none absolute inset-0 bg-slate-950/35" />
      ) : (
        <div className="pointer-events-none absolute inset-0 bg-white/35" />
      )}

      <div className="pointer-events-none absolute right-0 top-0 h-16 w-16 rounded-full bg-white/12 blur-2xl sm:h-24 sm:w-24" />

      <div className="relative flex items-start justify-between gap-2.5">
        <div className="min-w-0 flex-1">
          <div className={`text-[11px] font-semibold leading-4 sm:text-sm ${titleClass}`}>
            {title}
          </div>

          <div className={`mt-1.5 text-[2rem] font-black leading-none tracking-tight sm:mt-3 sm:text-3xl ${valueClass}`}>
            {value}
          </div>

          {subtitle ? (
            <div
              className={`mt-2 text-[11px] leading-5 sm:mt-3 sm:text-sm ${subtitleClass}`}
            >
              {subtitle}
            </div>
          ) : null}
        </div>

        {Icon ? (
          <div
            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-[18px] sm:h-12 sm:w-12 sm:rounded-2xl shadow-sm ${iconShellClass}`}
          >
            <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
          </div>
        ) : null}
      </div>
    </div>
  );
}
